// Maps a bundled image URL to a srcset built from pre-resized copies in src/assets/responsive.
const originals = import.meta.glob("/src/assets/*.{jpg,png}", { eager: true, import: "default" }) as Record<string, string>;
const variants = import.meta.glob("/src/assets/responsive/*.{jpg,png}", { eager: true, import: "default" }) as Record<string, string>;

const byUrl = new Map<string, string>();
for (const [path, url] of Object.entries(originals)) {
  const stem = path.split("/").pop()!.replace(/\.(jpg|png)$/, "");
  const entries = Object.entries(variants)
    .map(([p, u]) => {
      const m = p.split("/").pop()!.match(/^(.*)-(\d+)\.(jpg|png)$/);
      return m && m[1] === stem ? `${u} ${m[2]}w` : null;
    })
    .filter(Boolean) as string[];
  if (entries.length) byUrl.set(url, entries.join(", "));
}

export const srcSetFor = (src: string) => byUrl.get(src);
